import { cn } from "@/lib/utils";

const BAND_STYLES = {
  at_risk: { bg: "bg-rose-50", text: "text-rose-800", border: "border-rose-200", label: "At risk" },
  watch: { bg: "bg-amber-50", text: "text-amber-800", border: "border-amber-200", label: "Watch" },
  healthy: { bg: "bg-emerald-50", text: "text-emerald-800", border: "border-emerald-200", label: "Healthy" },
  strong: { bg: "bg-teal-50", text: "text-teal-800", border: "border-teal-200", label: "Strong" },
};

export function TrustBadge({ score, band, className, size = "md" }) {
  const s = BAND_STYLES[band] || BAND_STYLES.watch;
  const sizes = {
    sm: "text-[10px] px-1.5 py-0.5",
    md: "text-xs px-2.5 py-1",
    lg: "text-sm px-3 py-1.5",
  };
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 font-medium border rounded-sm",
        s.bg, s.text, s.border, sizes[size], className
      )}
      data-testid={`trust-badge-${band}`}
    >
      <span className="uppercase tracking-[0.15em] text-[9px] font-semibold">Trust</span>
      <span className="font-mono">{score}</span>
      <span className="text-current/70">·</span>
      <span>{s.label}</span>
    </span>
  );
}

const PRIORITY_STYLES = {
  critical: "bg-rose-600 text-white border-rose-700",
  high: "bg-rose-50 text-rose-800 border-rose-200",
  medium: "bg-amber-50 text-amber-800 border-amber-200",
  low: "bg-slate-50 text-slate-700 border-slate-200",
};

export function PriorityBadge({ priority }) {
  return (
    <span className={cn(
      "inline-flex items-center px-1.5 py-0.5 text-[10px] uppercase tracking-[0.15em] font-semibold border rounded-sm",
      PRIORITY_STYLES[priority] || PRIORITY_STYLES.medium,
    )}>
      {priority}
    </span>
  );
}
